import { Typography } from '@mui/material';
import { useState } from 'react';
import useAssignmentService, { ASSIGNMENT_DELETE_MESSAGE } from './assignmentService';
import { Button } from 'framework/ui/mui-builder';
import { Modal } from 'framework/ui/ui-builder';

interface DeleteStaffingAssignmentModalProps {
  assignmentId: string;
  isOpen: boolean;
  onClose: () => void;
  onDeleteAfter?: (assignmentId: string) => Promise<void>;
  onCancelClick?: () => void;
}

const DeleteStaffingAssignmentModal = ({
  assignmentId,
  isOpen,
  onDeleteAfter,
  onClose,
  onCancelClick,
}: DeleteStaffingAssignmentModalProps) => {
  const [isDeleteLoading, setDeleteLoading] = useState(false);
  const { deleteById } = useAssignmentService();

  const handleDeleteConfirm = async () => {
    setDeleteLoading(true);
    try {
      await deleteById(assignmentId);
      await onDeleteAfter?.(assignmentId);
      onClose();
    } finally {
      setDeleteLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      title="Are you sure?"
      onToggle={() => {
        onCancelClick?.();
      }}
      buttons={[
        <Button
          key="confirm-delete"
          variant="contained"
          color="error"
          onClick={handleDeleteConfirm}
          loading={isDeleteLoading}
          disabled={isDeleteLoading}
        >
          Delete
        </Button>,
      ]}
    >
      <Typography>{ASSIGNMENT_DELETE_MESSAGE}</Typography>
    </Modal>
  );
};

export default DeleteStaffingAssignmentModal;
